import React from "react";
import Row from "../components/Row";
import SavedSeries from "../components/SavedSeries";
import { useSavedSeries } from "../context/SavedSeriesContext";
import { useContent } from "../context/ContentContext";
import Main from "../components/Main";

const Home = () => {
  const { savedSeries } = useSavedSeries();
  const { categories, liveEpisodes = [] } = useContent(); // Provide default empty array

  return (
    <div>
      <Main />
      <div className="mx-auto text-center py-8">
        <h1 className="text-white text-xl md:text-3xl font-bold">
          Select a thumbnail below to watch digital broadcasts
        </h1>
        <h3 className="text-white text-s md:text-l font-bold">
        Looking for previous videos? <a className="text-blue-500" href="https://archive.ringette.live"> Click Here </a> to access the old website.
        </h3>
{/*         {(!liveEpisodes || liveEpisodes.length === 0) && (
          <h3 className="text-red-800 text-lg md:text-2xl font-bold">
            There are currently no live episodes
          </h3>
        )} */}
      </div>

      {savedSeries?.length > 0 && (
        <SavedSeries liveEpisodes={liveEpisodes} savedSeries={savedSeries} />
      )}

      {categories?.map((category) => (
        <Row
          key={category.query}
          category={category}
          liveEpisodes={liveEpisodes}
        />
      ))}
    </div>
  );
};

export default Home;
